import { Separator } from "@/components/ui/separator";
import type { BookingHistoryItem } from "@/types/booking-history/bookinghistory";
import { safeFormatDateTime } from "@/utils/formatDate";
import { ArrowRight, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

type BookingHistoryCardProps = {
  booking: BookingHistoryItem;
};

export function BookingHistoryCard({ booking }: BookingHistoryCardProps) {
  return (
    <Link
      to={`/booking-history/${booking.paymentId}`}
      className="group rounded-2xl bg-card p-4 shadow-xl transition-shadow hover:shadow-2xl"
    >
      <p className="font-semibold text-sm text-heading">{booking.bookingNo}</p>
      <Separator orientation="horizontal" className="mt-2 text-border" />
      <p className="text-primary text-xs font-medium mt-2 flex items-center gap-1">
        {booking.origin} <ArrowRight size={14} /> {booking.destination}
      </p>
      <div className="mt-4 flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 text-xs font-medium text-muted">
          <span>{safeFormatDateTime(booking.departureDate)}</span>
          {booking.returnDate &&
            !booking.returnDate.startsWith("0001-01-01") && (
              <>
                <Separator
                  orientation="vertical"
                  className="h-5 w-px text-border"
                />
                <span>{safeFormatDateTime(booking.returnDate)}</span>
              </>
            )}
        </div>
        <ChevronRight
          size={24}
          className="text-primary transition-transform duration-200 group-hover:translate-x-1"
        />
      </div>
      <p className="text-sm font-medium text-muted mt-4">
        {booking.passengerCount} Pax.
      </p>
    </Link>
  );
}
